import { StyleSheet } from "react-native";
import { Colors } from "react-native-paper";
import { pixelDimensions } from "../../../config/utils";

const styles = StyleSheet.create({
    content: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        padding: pixelDimensions(2)
    },
    header: {
        paddingVertical: pixelDimensions(5),
        justifyContent: "center",
        backgroundColor: Colors.indigo700
    },
    imageCoinBank: {
        height: pixelDimensions(50), 
        width: pixelDimensions(50) * 79/83
    },
    textClaimSuccess: {
        color: Colors.indigo700,
        fontSize: pixelDimensions(5),
        textAlign: "center",
        marginHorizontal: pixelDimensions(20)
    },
    textTitle: {
        fontSize: pixelDimensions(5),
        color: Colors.white,
        textAlign: "center"
    },
    viewBase: {
        flex: 1,
        backgroundColor: Colors.grey300,
    },
    
})

export default styles;